import React, { useCallback, useState } from 'react';

import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import { ProgramRetrieve } from 'types';

import EditProgramDrawer from './EditProgramDrawer';
import ProgramCalendarAgendaView from './ProgramCalendarAgendaView';
import ProgramCalendarMonthView from './ProgramCalendarMonthView';
import ProgramCalendarNavigationButton from './ProgramCalendarNavigationButton';
import { FilterTerms, ProgramCalendarView } from './types';

interface ProgramCalendarProps {
  searchFilters: FilterTerms;
  permission?: boolean;
}

const ProgramCalendar = ({ searchFilters, permission = true }: ProgramCalendarProps): JSX.Element => {
  const [view, setView] = useState<ProgramCalendarView>('month'); // should default to week
  const calendarMaxDate = dayjs(new Date()).add(1, 'year').toDate();
  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [program, setProgram] = useState<ProgramRetrieve | undefined>();
  const [isProgramEditFormOpen, { open: openProgramEditForm, close: closeProgramEditForm }] =
    useDisclosure(false);

  const renderProgramCalendarNavigationButtons = (): JSX.Element => {
    return <ProgramCalendarNavigationButton view={view} setView={setView} />;
  };

  const handleProgramEdit = useCallback((): void => {
    openProgramEditForm();
  }, [openProgramEditForm]);

  return (
    <>
      {view === 'month' && (
        <ProgramCalendarMonthView
          programCalendarNavigationButtons={renderProgramCalendarNavigationButtons}
          setDate={setDate}
          setView={setView}
          searchFilters={searchFilters}
          calendarMaxDate={calendarMaxDate}
          handleEditProgram={handleProgramEdit}
          setProgram={setProgram}
        />
      )}
      {view === 'agenda' && (
        <ProgramCalendarAgendaView
          programCalendarNavigationButtons={renderProgramCalendarNavigationButtons}
          date={date}
          setDate={setDate}
          searchFilters={searchFilters}
          calendarMaxDate={calendarMaxDate}
          handleEditProgram={handleProgramEdit}
          setProgram={setProgram}
        />
      )}
      <EditProgramDrawer
        opened={isProgramEditFormOpen}
        closeHandler={closeProgramEditForm}
        program={program}
        permission={permission}
      />
    </>
  );
};

export default ProgramCalendar;
